import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";

var _templateObject, _templateObject2, _templateObject3, _templateObject4;

import styled from 'styled-components';
import { darken } from 'polished';
export var SearchResultItem = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: ", ";\n  overflow: hidden;\n\n  & > div:not(:last-child) {\n    margin-right: ", ";\n    margin-bottom: ", ";\n  }\n"])), function (props) {
  return props.direction;
}, function (props) {
  return props.direction === 'row' && '0.5rem';
}, function (props) {
  return props.direction === 'column' && '0rem';
});
SearchResultItem.defaultProps = {
  direction: 'row'
};
export var SearchResultLabel = styled.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  background-color: ", ";\n  color: ", ";\n  margin: 0 -0.83rem;\n  padding: 0 0.83rem;\n"])), function (props) {
  return props.theme.colors.grey;
}, function (props) {
  return darken(0.5, props.theme.colors.darkGrey);
});
export var SearchResultMain = styled.div(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n"])));
export var SearchResultSecondary = styled.div(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  color: ", ";\n  font-size: 0.8rem;\n"])), function (props) {
  return props.theme.colors.darkGrey;
});